/**************************************************
 * Nombre:       Seccion_Home
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Portada from "./Componentes/Home_Portada";
import Home_Lineas from "./Componentes/Home_Lineas";
import Home_Oferta_Edutavita from "./Componentes/Home_Oferta_Edutavita";
import Home_Somos from "./Componentes/Home_Somos";
import Home_Buena_Educacion from "./Componentes/Home_Buena_Educacion";
import Home_Perspectiva from "./Componentes/Home_Perspectiva";
import Home_Perspectiva_Escuelas from "./Componentes/Home_Perspectiva_Escuelas";
import Home_Programas from "./Componentes/Home_Programas";

const Seccion_Home = () => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                <Home_Portada/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Home_Lineas/>
            </Grid>

            <Grid id={'catalogo'} container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                <Home_Oferta_Edutavita/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Home_Somos/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Home_Buena_Educacion/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Home_Perspectiva/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 16}}>
                <Home_Perspectiva_Escuelas/>
            </Grid>

            <Grid  container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                <Home_Programas/>
            </Grid>

            {/*}      <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                <Home_Indicadores/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                <Home_Testimonios/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                <Nosotros_Home/>
            </Grid>*/}


        </Grid>
    )

}
export default Seccion_Home    